import { render, staticRenderFns } from "./OrderAssignments.vue?vue&type=template&id=21a9988e&"
import script from "./OrderAssignments.vue?vue&type=script&lang=ts&"
export * from "./OrderAssignments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports